
import { useState } from "react";

interface FeedbackStats {
  positive: number;
  neutral: number;
  negative: number;
}

export function useFeedback() {
  const [feedbackStats, setFeedbackStats] = useState<FeedbackStats>({
    positive: 0,
    neutral: 0,
    negative: 0
  });
  
  const handleFeedback = (feedbackType: "positive" | "neutral" | "negative") => {
    setFeedbackStats(prev => ({
      ...prev,
      [feedbackType]: prev[feedbackType] + 1
    }));
    
    return feedbackType;
  };
  
  return {
    feedbackStats,
    handleFeedback
  };
}
